import { COLORS } from "utils/config/reference";
import { generateRandomLightColor } from "utils/methods/math";
import { v4 as uuid } from "uuid";

export const generateRandomNormalColor = () => {
  const r = Math.floor(Math.random() * 101) + 100;
  const g = Math.floor(Math.random() * 101) + 100;
  const b = Math.floor(Math.random() * 101) + 100;
  return `rgb(${r}, ${g}, ${b})`;
};

export const getInitialCellCount = (size) => {
  switch (size) {
    case 3:
      return 18;
    case 4:
      return 32;
    case 5:
      return 50;
    default:
      return null;
  }
};

export const createGridTeacher = (size, selectedVocabData = []) => {
  const baseCellCount = getInitialCellCount(size);

  let cells = [];
  let i = 0;

  for (let row = 0; row < baseCellCount; row++) {
    cells.push({
      cellIndex: row,
      id: uuid(),
      value: selectedVocabData[row] ? selectedVocabData[row] : "",
      backgroundColor: COLORS[i] ? COLORS[i++] : generateRandomLightColor(),
      percant: 0,
      isCustom: false,
      selected: false,
    });
  }
  return cells;
};

export const createGrid = (size) => {
  let i = 0;
  const data = Array.from({ length: size }, (_, row) =>
    Array.from({ length: size }, (_, col) => ({
      row,
      col,
      type: "",
      value: "",
      backgroundColor: COLORS[i] ? COLORS[i++] : generateRandomLightColor(),
      percant: 0,
    }))
  );
  return data;
};

export const makeRowColGrid = (data, size, selectedType = "") => {
  if (!Array.isArray(data)) {
    console.error("Invalid data: Expected an array but received", data);
    return [];
  }
  const filterCondition =
    selectedType === "OnlyImage" || selectedType === "Image"
      ? (item) => item?.imageUrl?.trim() !== ""
      : (item) => item?.value?.trim() !== "";
  const itemsWithValue = data.filter(filterCondition);

  if (!itemsWithValue.length) {
    console.warn("No items with the required condition found.");
    return [];
  }
  const shuffled = [...itemsWithValue].sort(() => Math.random() - 0.5);
  const selectedItems = shuffled.slice(0, size * size);
  const grid = [];
  for (let i = 0; i < size; i++) {
    grid[i] = selectedItems.slice(i * size, (i + 1) * size);
  }
  return grid;
};

export const BINGO_TYPE = [
  { label: "Texts", value: "Word" },
  { label: "Only Images", value: "OnlyImage" },
  { label: "Images with Texts", value: "Image" },
  { label: "Vocabularies with Texts", value: "VocabWord" },
  { label: "Vocabularies with Images", value: "VocabImage" },
];

export const BINGO_TYPE_RESOURCE = [
  { label: "Texts", value: "Word" },
  { label: "Only Images", value: "OnlyImage" },
  { label: "Images with Texts", value: "Image" },
];

export const BINGO_SIZE = [
  {
    value: 3,
    label: "3 X 3",
  },
  {
    value: 4,
    label: "4 X 4",
  },
  {
    value: 5,
    label: "5 X 5",
  },
];

export const isMandtoryCells = (bingoSize) => {
  const size = Number(bingoSize);
  switch (size) {
    case 3:
      return size * size + 5;
    case 4:
      return size * size + 5;
    case 5:
      return size * size + 5;
    default:
      return size * size;
  }
};

export const getMandatoryCellMessage = (bingoSize) => {
  const sizeMap = {
    3: { totalCells: 18, mandatoryCells: 14 },
    4: { totalCells: 32, mandatoryCells: 21 },
    5: { totalCells: 50, mandatoryCells: 30 },
  };

  const config = sizeMap[bingoSize];
  return config
    ? ` There are a total of ${config.totalCells} cells, with ${config.mandatoryCells} cells being mandatory.`
    : "";
};
